package fr.frux.core.database

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class Site(
  public val id: Long,
  public val name: String,
  public val description: String?,
  public val latitude: Double,
  public val longitude: Double,
  public val access_rule: String,
  public val manager_name: String?,
  public val has_owner: Long,
  public val trees_count: Long,
  public val created_by: Long,
  public val created_by_username: String?,
  public val created_at: Long?,
  public val cached_at: Long,
  public val next_harvest_id: Long?,
  public val next_harvest_at: Long?,
  public val next_harvest_hosted: Long?,
)
